export default "__VITE_ASSET__BwwO5ZgR__"